var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16.264 16.263"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Icon Close",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 1",
    d: "M1.061 1.061l14.142 14.142"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 2",
    d: "M15.204 1.061L1.062 15.203"
  }))));
}
export default SvgClose;